import { cx } from 'class-variance-authority'
import React from 'react'
import { Typography } from '@material-tailwind/react/components/Typography'

interface HomeHeadingProps {
  children: React.ReactNode
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  additionalClasses?: string
}

export const HomeHeading = ({
  children,
  tag = 'h2',
  additionalClasses = '',
}: HomeHeadingProps) => {
  const headingClass = cx(
    'font-bold text-center text-primary text-4xl xl:text-5xl !leading-snug',
    additionalClasses,
    tag === 'h1' && 'xl:text-6xl',
  )

  return (
    <Typography variant={tag} className={headingClass}>
      {children}
    </Typography>
  )
}
